module.exports = __webpack_public_path__ + "static/media/OM.bcbf03ed.svg";